import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';
//import { grey } from '@material-ui/core/colors';

import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tab, Tabs} from '@material-ui/core'
import {Container, Box, IconButton} from '@material-ui/core'
import {Button, FormControl, Checkbox, TextField, InputLabel, MenuItem, Select } from '@material-ui/core';
//Typography, Paper
//import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {MoreVert} from '@material-ui/icons';
import {EditUserPermissionsDialog} from './EditUserPermissionsDialog';
import { checkPassword, isInteger, isNumber } from '../../../api/validators';
import { CustomField } from '../../../components/CustomField';
import { TabPanel } from '../../../components/TabPanel';
import { PERMISSION_DEFAULT } from '../../../FleetConsole/api/ServerApi';
import { getObjectByID } from '../../../api/helpers';

class EditUserDialog_ extends React.Component{

    constructor(props){
        super(props)

        let user = JSON.parse(JSON.stringify(this.props.user))

        //user defaults
        //console.log('EditUserDialog')
        //console.log(props)

        if(!user.ID) user = {
            Login: '',
            Name: '',
            Password: '',
            Priority: 0,
            ProfileID: 'EREREREREREREREREREREQ==',
            ScanListID: "AAAAAAAAAAAAAAAAAAAAAA==",
            Permissions: -1,
            LocationPeriod: '',
            //RadioID: '',
            //SipID: '',
            Locked: false,
            SingleLogin: false
        }

        this.state = {
            user: {...user},
            errors:{
                Login: false, 
                Name: false,
                Password: false,
                //Priority: false,
                //ProfileID: false,
                //Permissions: false,
                LocationPeriod: false,
                DmrRadioID: false,
                SipID: false
                //Locked: false
            },
            panelsExpanded:{
                General: true,
                CustomFields: true
            },
            permissionsDialogOpen: false,
            changed: false,
            permissionsType: user.ID && user.Permissions>=0 ? 0 : -1,
            tab: 0
        }   

        this.handleTabChange = this.handleTabChange.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.handleInput = this.handleInput.bind(this)
        this.handleInputExtra = this.handleInputExtra.bind(this)

        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleTabChange(event, newValue){
        this.setState({tab: newValue})
    }

    handleSave(){
        if(this.checkForm()){
            let user = {...this.props.user, ...this.state.user}
            this.props.onAction({type: 'USER_EDITOR_SAVE', user: user})
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'USER_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'USER_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const user = {...this.state.user, [event.target.name]: val}

        const err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({user: user, ...changed, ...errors})
    }

    handleInputExtra(event, err){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const user = {...this.state.user}

        if(user.ExtraFields===undefined){
            user.ExtraFields = {}
        }
        user.ExtraFields[event.target.name] = val

        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({user: user, ...changed, ...errors})
    }

    handlePermissionsTypeChange(event){
        let permissions = {}
        if(event.target.value===0 && this.state.user.Permissions===-1){
            permissions = {Permissions: PERMISSION_DEFAULT }//13500882
        }else if(event.target.value===-1){
            permissions = {Permissions: -1}
        }

        const user = {...this.state.user, ...permissions}
        this.setState({permissionsType: event.target.value, user: user})
    }

    handleAction(action){
        switch(action.type){
            case 'USER_PERMISSIONS_EDITOR_OPEN':
                this.setState({permissionsDialogOpen: true})
                break;

            case 'USER_PERMISSIONS_EDITOR_CLOSE':
                this.setState({permissionsDialogOpen: false})
                break;

            case 'USER_PERMISSIONS_EDITOR_SAVE':
                let changed = !this.state.changed ? {changed: true} : {}

                this.setState({permissionsDialogOpen: false})

                let permissions_1 = action.permissions % 4294967296
                let permissions_2 = Math.trunc(action.permissions/4294967296)

                const user = {...this.state.user, Permissions: permissions_1, Permissions2: permissions_2}

                //console.log('USER_PERMISSIONS_EDITOR_SAVE')
                //console.log(user)

                this.setState({user: user, ...changed})
                break;

            default: 
                this.props.onAction(action)
        }
    }

    validate(name, value){
        const {t} = this.props
        let error = false

        switch(name){
            case 'Login': 
                if(!value){
                    error = t('LoginIsEmpty')
                }
                break

            case 'Name':
                if(!value){
                    error = t('NameIsEmpty')
                }
                break

            case 'LocationPeriod':
            case 'DmrRadioID':
                if(value && !isNumber(value)){
                    error = this.label(name) + ': ' + t('IsNotNumber')
                }else if(value && !isInteger(value)){
                    error = t('IsNotInteger')
                }else if(!value){
                    error = false
                }
                break
                
            case 'Password':
                if(!checkPassword(value, this.props.passwordPolicy)){
                    error = t('BadPassword')
                }
                break

            default:
                console.log('Empty validator '+name)
        }

        return error
    }

    label(name){
        let {t} = this.props
        switch(name){
            default: return t(name)
        }
    }


    checkForm(){
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            let field = getObjectByID(i, this.props.fieldsTemplate.Fields, 'Name')

            if(field){
                if(errors[i]){
                    check = false
                }
            }else{
                let v = this.state.user[i]
                let error = this.validate(i, v)
                errors[i] = error
                if(error) {
                    console.error({field: i, value: v, error: error})
                    check = false
                }
            }
        }
        this.setState({errors: errors})
        return check
    }

    togglePanel(event, expanded, panel){

        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })

    }

    render(){
        const {t} = this.props

        const title = this.props.action==='add'?t('NewUser'):t('EditUser')

        const margin = {margin:'16px 0 8px 0'}

        let userPermissionsDialog = '';
        if(this.state.permissionsDialogOpen){
            //console.log('this.state.user')
            //console.log(this.state.user)
            const {Permissions, Permissions2}  = this.state.user
            const permissions = Permissions + (Permissions2 ? Permissions2 * 4294967296 : 0)

            userPermissionsDialog = (
                <EditUserPermissionsDialog
                    open={this.state.permissionsDialogOpen}
                    permissions={permissions}
                    onAction={this.handleAction}
                    />
            );
        }

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            },
            tab:{
                minWidth:80
            },
            tabPanel:{
                minHeight: 300
            }
        };

        const extraFields = this.state.user.ExtraFields ? this.state.user.ExtraFields : {}


        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:550}}>

  
            <Tabs  value={this.state.tab} 
                variant="scrollable"
                scrollButtons="auto"
                onChange={this.handleTabChange} aria-label="simple tabs example"
                indicatorColor="primary">
                <Tab wrapped style={styles.tab} label={t("General")} id="tab-0" aria-controls="tabpanel-0" />
                <Tab wrapped style={styles.tab} label={t("DMR")} id="tab-1" aria-controls="tabpanel-1" />
                <Tab wrapped style={styles.tab} label={t("SIP")} id="tab-2" aria-controls="tabpanel-2" />
                <Tab wrapped style={styles.tab} label={t("ExtraFields")} id="tab-3" aria-controls="tabpanel-3" />
            </Tabs>
  

            <TabPanel value={this.state.tab} index={0} style={styles.tabPanel}>

                <Box textAlign="center">
                    <TextField name="Login"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.Login?this.state.errors.Login:t('Login')}
                        autoComplete="new-password"
                        error={this.state.errors.Login!==false}
                        value={this.state.user.Login}
                        onChange={this.handleInput}
                    />
                </Box>

                <Box textAlign="center">
                    <TextField name="Name"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                        autoComplete="new-password"
                        error={this.state.errors.Name!==false}
                        value={this.state.user.Name}
                        onChange={this.handleInput}
                    />
                </Box>

                <Box textAlign="center">
                    <TextField type="password" name="Password" margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.Password?this.state.errors.Password:t('Password')}
                        autoComplete="new-password"
                        error={this.state.errors.Password!==false}
                        value={this.state.user.Password}
                        onChange={this.handleInput}
                    />
                </Box>

                <Box textAlign="left">
                    <FormControl style={{...margin, width: '100%'}}>
                        <InputLabel htmlFor="Priority">{t('Priority')}</InputLabel>
                        <Select
                            value={this.state.user.Priority}
                            onChange={this.handleInput}
                            inputProps={{
                                name: 'Priority',
                                id: 'Priority',
                            }}
                            >
                            <MenuItem key="14" value={14}>+14</MenuItem>
                            <MenuItem key="13" value={13}>+13</MenuItem>
                            <MenuItem key="12" value={12}>+12</MenuItem>
                            <MenuItem key="11" value={11}>+11</MenuItem>
                            <MenuItem key="10" value={10}>+10</MenuItem>
                            <MenuItem key="9" value={9}>+9</MenuItem>
                            <MenuItem key="8" value={8}>+8</MenuItem>
                            <MenuItem key="7" value={7}>+7</MenuItem>
                            <MenuItem key="6" value={6}>+6</MenuItem>
                            <MenuItem key="5" value={5}>+5</MenuItem>
                            <MenuItem key="4" value={4}>+4</MenuItem>
                            <MenuItem key="3" value={3}>+3</MenuItem>
                            <MenuItem key="2" value={2}>+2</MenuItem>
                            <MenuItem key="1" value={1}>+1</MenuItem>
                            <MenuItem key="0" value={0}>{t('Default')}</MenuItem>
                            <MenuItem key="-1" value={-1}>-1</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Box textAlign="left">
                    <FormControl style={{...margin, width: '100%'}}>
                        <InputLabel htmlFor="ProfileID">{t('Profile')}</InputLabel>
                        <Select
                            value={this.state.user.ProfileID}
                            onChange={this.handleInput}
                            inputProps={{name: 'ProfileID', id: 'ProfileID'}}
                            >
                            {this.props.profiles.map(profile=>
                                <MenuItem key={profile.ProfileID} value={profile.ProfileID}>{profile.Name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Box>

                <Box textAlign="center">
                    <Grid container>
                        <Grid item xs={11} align="left">

                            <FormControl style={{...margin, width: '100%'}}>
                                <InputLabel htmlFor="permissionsType">{t('Permissions')}</InputLabel>
                                <Select
                                    value={this.state.permissionsType}
                                    onChange={this.handlePermissionsTypeChange.bind(this)}
                                    
                                    inputProps={{
                                        name: 'permissionsType',
                                        id: 'permissionsType',
                                    }}
                                    >
                                    <MenuItem key="-1" value={-1}>{t('InheritedFromNetwork')}</MenuItem>
                                    <MenuItem key="0" value={0}>{t('Custom')}</MenuItem>
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={1} style={{verticalAlign:'bottom', paddingTop:33}}>
                            <IconButton disabled={this.state.permissionsType===-1} 
                                size="small" color="inherit" aria-label="more permissions" component="span"
                                style={{width2: 16, height2: 16}}
                                onClick={()=>{this.handleAction({type: 'USER_PERMISSIONS_EDITOR_OPEN'})}}>
                                <MoreVert />
                            </IconButton>
                        </Grid>
                    </Grid>
                    {userPermissionsDialog}
                </Box>

                <Box textAlign="left">
                    <FormControl style={{...margin, width: '100%'}}>
                        <InputLabel htmlFor="ScanListID">{t('ScanList')}</InputLabel>
                        <Select
                            value={this.state.user.ScanListID}
                            onChange={this.handleInput}
                            inputProps={{name: 'ScanListID', id: 'ScanListID'}}
                            >
                            <MenuItem key={'AAAAAAAAAAAAAAAAAAAAAA=='} value={'AAAAAAAAAAAAAAAAAAAAAA=='}>{''}</MenuItem>
                            {this.props.scanlists.map(scanlist=>
                                <MenuItem key={scanlist.ID} value={scanlist.ID}>{scanlist.Name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Box>


                <Box textAlign="center">
                    <TextField name="LocationPeriod"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.LocationPeriod?this.state.errors.LocationPeriod:t('LocationPeriod')}
                        autoComplete="new-password"
                        error={this.state.errors.LocationPeriod!==false}
                        value={this.state.user.LocationPeriod}
                        onChange={this.handleInput}
                    />
                </Box>

                <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={this.state.user.Beacons}
                                onChange={this.handleInput}
                                name="Beacons"
                                />
                                {t('IndoorTracking')}
                        </label>
                    </FormControl>
                </Box>

                <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={this.state.user.Locked}
                                onChange={this.handleInput}
                                name="Locked"
                                />
                                {t('Blocked')}
                        </label>
                    </FormControl>
                </Box>

                <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={this.state.user.SingleLogin}
                                onChange={this.handleInput}
                                name="SingleLogin"
                                />
                                {t('RestrictSimultaneousLoginFromDifferentDevices')}
                        </label>
                    </FormControl>
                </Box>

                <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={this.state.user.DeviceLogin}
                                onChange={this.handleInput}
                                name="DeviceLogin"
                                />
                                {t('AutomaticLoginForDevice')}
                        </label>
                    </FormControl>

                    <FormControl style={{...margin, width: '100%'}}>    
                        <InputLabel htmlFor="LoginDeviceID">{t('SelectDevice')}</InputLabel>
                        <Select
                            value={this.state.user.LoginDeviceID}
                            onChange={this.handleInput}
                            disabled={!this.state.user.DeviceLogin}
                            inputProps={{
                                name: 'LoginDeviceID',
                                id: 'LoginDeviceID',
                            }}
                            >
                            {this.props.devices.map(item=>
                            <MenuItem key={item.ID} value={item.ID}>{item.Manufacturer} {item.Model}</MenuItem>
                            )}
           
                        </Select>
                    </FormControl>

                </Box>

            </TabPanel>


            <TabPanel value={this.state.tab} index={1} style={styles.tabPanel}>

                <Box textAlign="center">
                    <TextField name="DmrRadioID"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.DmrRadioID?this.state.errors.DmrRadioID:t('VirtualRadioID')}
                        autoComplete="new-password"
                        error={this.state.errors.DmrRadioID!==false}
                        value={this.state.user.DmrRadioID}
                        onChange={this.handleInput}
                    />
                </Box>

            </TabPanel>

            <TabPanel value={this.state.tab} index={2} style={styles.tabPanel}>

                <Box textAlign="center">
                    <TextField name="SipID"  margin="normal"
                        style={{width: '100%'}}
                        label={this.state.errors.SipID?this.state.errors.SipID:t('SipID')}
                        autoComplete="new-password"
                        error={this.state.errors.SipID!==false}
                        value={this.state.user.SipID}
                        onChange={this.handleInput}
                    />
                </Box>

            </TabPanel>


            <TabPanel value={this.state.tab} index={3} style={styles.tabPanel}>
                {this.props.fieldsTemplate.Fields.map(item => 
                    <Box textAlign="left" key={item.Name}>
                        <CustomField name={item.Name} 
                            type={item.Type} 
                            value={extraFields[item.Name]}
                            label={item.Name}
                            onChange={this.handleInputExtra}/>
                    </Box>
                )}
            </TabPanel>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditUserDialog = withTranslation()(EditUserDialog_);